import { render, staticRenderFns } from "./TrainingSchools.vue?vue&type=template&id=23a8da12&scoped=true"
import script from "./TrainingSchools.vue?vue&type=script&lang=js"
export * from "./TrainingSchools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a8da12",
  null
  
)

export default component.exports